import React from 'react';

export function Loading() {
  return <span className='loading'></span>
}